import {useEffect, useState} from 'react'
import RoleContext from './roleContext'
import {RoleContextValue} from '../types/OtherTypes'

const RoleState = (props: {children: any}) => {
  const [features, setFeatures] = useState<RoleContextValue['features']>([])
  const [roleName, setRoleName] = useState<string | undefined>(undefined)
  
  const updateState = (features: RoleContextValue['features'], roleName?: string) => {
    setFeatures(features)
    setRoleName(roleName)
  }

  useEffect(() => {
    const firstRole: string | null = sessionStorage.getItem('currentUserRole')
    if (firstRole) {
      const Role: {
        roleName?: string
        features: RoleContextValue['features']
      } = JSON.parse(firstRole)
      if (Role !== null) {
        setFeatures(Role.features)
        setRoleName(Role.roleName)
      }
    }
  }, [])

  return (
    <>
      <RoleContext.Provider value={{features, roleName, updateState}}>{props.children}</RoleContext.Provider>
    </>
  )
}

export default RoleState
